<template>
  <div
    class="slido-wrap"
    :class="[{ 'slido-mobile': isMobile }, itemClass]"
    v-if="link"
  >
    <iframe :src="link" frameborder="0"></iframe>
    {{ itemClass }}
  </div>
</template>

<script>
import isMobileMixin from "@/mixins/isMobileMixin";
export default {
  mixins: [isMobileMixin],
  props: {
    link: {
      // https://app.sli.do/event/7q0zb4jq/polls
      type: String,
    },
    orientation: {
      // true === landscape
      // false === portriat
    },
    itemClass: {
      type: String,
    },
  },
  data() {
    return {};
  }
};
</script>

<style scoped lang="scss">
.slido-wrap {
  width: 350px;
  height: 100%;
  &.slido-mobile {
    min-height: 400px;
    width: 100%;
    iframe {
      width: 100%;
      height: calc(100vh - var(--nav-height));
    }
  }
  iframe {
    width: 100%;
    height: 100%;
  }
}
</style>
